import type {
  AnswerSelectDto,
  QuestionSelectDto,
  SurveySnapshotChapterSelectDto,
  SurveySnapshotSectionSelectDto,
} from '@@types/api.types';
import { AssessmentSectionOverview } from '@components/pages/assessment-shell/components/assessment-section-overview.component';
import { useSafeReturnTo } from '@hooks/return-to.hook';
import { getChapterLabel, isQuestionAnswered } from '@utils/survey.util';
import { useNavigate, useParams } from 'react-router-dom';

type SurveySectionProps = {
  answers?: AnswerSelectDto[];
  chapters?: SurveySnapshotChapterSelectDto[];
  currentChapterId?: string;
  questions?: QuestionSelectDto[];
  sections: SurveySnapshotSectionSelectDto[];
};

export const SurveySection: React.FC<SurveySectionProps> = (props) => {
  const { answers, chapters, currentChapterId, questions, sections } = props;
  const { surveyId, technologyId } = useParams();
  const navigate = useNavigate();
  const { returnToSearch } = useSafeReturnTo();

  const chapter = chapters?.find((chapter) => chapter.id === currentChapterId);
  const chapterIndex = chapters?.findIndex((chapter) => chapter.id === currentChapterId) ?? 0;

  return (
    <AssessmentSectionOverview
      chapterIndex={chapterIndex}
      onSectionSelect={(sectionId) =>
        navigate(`/technology/${technologyId}/survey/${surveyId}/section/${sectionId}${returnToSearch}`)
      }
      sections={sections.map((section) => ({
        answered:
          section.questions.filter((questionId) => {
            const question = questions?.find((item) => item.id === questionId);

            return isQuestionAnswered({
              answers,
              questionId,
              questionType: question?.type,
              sectionId: section.id,
            });
          }).length ?? 0,
        id: section.id,
        title: section.name,
        total: section.questions.length,
      }))}
      title={chapter ? getChapterLabel({ identifier: chapter.identifier, name: chapter.name }) : ''}
    />
  );
};
